

// export default Register;
import React, { useState, useEffect } from 'react';
import { hamburguesas, desserts, drinks } from '../../Variables';
import jsPDF from 'jspdf';
import imgPDF from './../../asses/not-found/pdficon-removebg-preview.png'

function Register({setConsoleAdmin, consoleAdmin, setNewFetch, newFetch}) {
  const [data, setData] = useState([]);
  const [visibilityData, setVisibilityData] = useState(false);
  const [visibilityInfo, setVisibilityInfo] = useState(false);
  const [dataAdd, setDataAdd] = useState(null);
  const [thisDate, setThisDate] = useState();

  const [visibilityRegister1, setVisibilityRegister1] = useState(true);
  const [visibilityRegister2, setVisibilityRegister2] = useState(false);
  const [visibilityRegister2Food, setVisibilityRegister2Food] = useState(true);
  const [visibilityRegister2Drink, setVisibilityRegister2Drink] = useState(false);
  const [visibilityRegister2Desserts, setVisibilityRegister2Desserts] = useState(false);


  const [testState, setTestState] = useState("")

useEffect(() => {
  console.log("2******2********2*****esta es la estructura de data: " + data)
    
}, [testState])

// const functionSavePdfDescription = (item) => {
//   // Primero parseamos `item.data`, que es una cadena JSON que contiene un array de órdenes
//   let orders;
//   try {
//     orders = JSON.parse(item.data); // `orders` es ahora un array de objetos
//   } catch (e) {
//     console.error('Error al parsear item.data:', e);
//     return; // Si ocurre un error en el parseo, no continuamos
//   }

//   const pdf = new jsPDF();
//   const marginLeft = 20;  // Margen izquierdo
//   const marginTop = 20;   // Margen superior
//   const marginBottom = 20; // Margen inferior
//   const marginRight = 20;  // Margen derecho
//   const pageHeight = 297;  // Altura de la página A4 en mm
//   let yPosition = marginTop; // Coordenada Y inicial respetando el margen

//   // Título principal
//   pdf.setFontSize(16);
//   pdf.text('Registro de Pedidos', marginLeft + 60, yPosition);  // Ajuste horizontal con margen izquierdo
//   yPosition += 10;

//   // Iteramos sobre cada pedido (order) en el array `orders`
//   orders.forEach((order) => {
//     // Título del pedido
//     pdf.setFontSize(14);
//     pdf.text(`Pedido ID: ${order.id}`, marginLeft, yPosition);
//     yPosition += 10;

//     // Imprimir todas las propiedades del objeto 'order'
//     pdf.setFontSize(12);
//     Object.keys(order).forEach((key) => {
//       const value = order[key];
//       if (key !== 'products') { // No imprimir 'products' aquí
//         pdf.text(`${key}: ${value}`, marginLeft, yPosition);
//         yPosition += 10; // Espacio entre líneas
//       }
//     });

//     yPosition += 10; // Espacio antes de los productos

//     // Detalles de los productos (en caso de que 'products' esté presente)
//     pdf.setFontSize(12);
//     pdf.text('Productos:', marginLeft, yPosition);
//     yPosition += 10;

//     // Ahora parseamos `order.products` que es una cadena JSON
//     let products;
//     try {
//       products = JSON.parse(order.products); // Convertimos la cadena JSON en un array de productos
//     } catch (e) {
//       console.error('Error al parsear products:', e);
//       return; // Si ocurre un error al parsear los productos, no continuamos
//     }

//     // Iteramos sobre los productos y los imprimimos
//     products.forEach((product, index) => {
//       pdf.text(`${index + 1}. ${product.name} - $${product.price}`, marginLeft, yPosition);
//       yPosition += 8; // Espacio entre productos
//       pdf.text(`Ingredientes: ${product.ingredients}`, marginLeft + 10, yPosition);  // Ajuste de indentación para los detalles
//       yPosition += 8;
//       pdf.text(`Kcal: ${product.kcal}`, marginLeft + 10, yPosition);
//       yPosition += 10; // Espacio entre productos
//     });

//     // Espacio final antes de pasar al siguiente pedido
//     yPosition += 10;

//     // **Ajuste importante aquí**: Verificar si `yPosition` excede el margen inferior y añadir página nueva
//     if (yPosition > pageHeight - marginBottom ) {  // Si la página se llena (considerando el margen inferior)
//       pdf.addPage();  // Agregar una nueva página
//       yPosition = marginTop; // Reiniciar la posición Y al margen superior
//     }
//   });

//   // Guardar el PDF con un nombre dinámico usando el ID del primer pedido (o el que quieras)
//   pdf.save(`${item.date}-Pedidos.pdf`);
// };
const functionSavePdfDescription = (item) => {
  let orders;
  try {
    orders = JSON.parse(item.data); // `orders` es ahora un array de objetos
  } catch (e) {
    console.error('Error al parsear item.data:', e);
    return;
  }

  const pdf = new jsPDF();
  const marginLeft = 20;  // Margen izquierdo
  const marginTop = 20;   // Margen superior
  const marginBottom = 20; // Margen inferior
  const marginRight = 20;  // Margen derecho
  const pageHeight = 297;  // Altura de la página A4 en mm
  let yPosition = marginTop; // Coordenada Y inicial respetando el margen

  // Título principal
  pdf.setFontSize(16);
  pdf.text('Registro de Pedidos', marginLeft + 60, yPosition);  // Ajuste horizontal con margen izquierdo
  yPosition += 10;

  orders.forEach((order) => {
    // Verificar si la posición excede el margen inferior antes de imprimir
    const checkForNewPage = (extraHeight) => {
      if (yPosition + extraHeight > pageHeight - marginBottom) {
        pdf.addPage();  // Agregar una nueva página
        yPosition = marginTop; // Reiniciar la posición Y al margen superior
      }
    };

    // Título del pedido
    checkForNewPage(10); // Comprobamos el espacio antes de agregar el título
    pdf.setFontSize(14);
    pdf.text(`Pedido ID: ${order.id}`, marginLeft, yPosition);
    yPosition += 10;

    // Imprimir todas las propiedades del objeto 'order'
    pdf.setFontSize(12);
    Object.keys(order).forEach((key) => {
      const value = order[key];
      if (key !== 'products') { // No imprimir 'products' aquí
        checkForNewPage(10); // Comprobamos el espacio antes de cada línea
        pdf.text(`${key}: ${value}`, marginLeft, yPosition);
        yPosition += 10;
      }
    });

    yPosition += 10; // Espacio antes de los productos
    checkForNewPage(10); // Comprobamos el espacio antes de la sección de productos

    // Detalles de los productos (en caso de que 'products' esté presente)
    pdf.setFontSize(12);
    pdf.text('Productos:', marginLeft, yPosition);
    yPosition += 10;

    let products;
    try {
      products = JSON.parse(order.products); // Convertimos la cadena JSON en un array de productos
    } catch (e) {
      console.error('Error al parsear products:', e);
      return;
    }

    products.forEach((product, index) => {
      checkForNewPage(18); // Verificamos espacio antes de cada producto (considerando su descripción)

      pdf.text(`${index + 1}. ${product.name} - $${product.price}`, marginLeft, yPosition);
      yPosition += 8; // Espacio entre productos
      pdf.text(`Ingredientes: ${product.ingredients}`, marginLeft + 10, yPosition);  // Ajuste de indentación
      yPosition += 8;
      pdf.text(`Kcal: ${product.kcal}`, marginLeft + 10, yPosition);
      yPosition += 10; // Espacio entre productos
    });

    // Espacio final antes de pasar al siguiente pedido
    yPosition += 20;
    checkForNewPage(10); // Verificamos espacio antes de pasar al siguiente pedido
  });

  // Guardar el PDF con un nombre dinámico usando el ID del primer pedido (o el que quieras)
  pdf.save(`${item.date}-Pedidos.pdf`);
};



const functionSavePdfDescription2 = (item) => {
  // Primero parseamos `item.data`, que es una cadena JSON que contiene un array de órdenes
  let orders;
  const productCount = {};
  try {
    orders = JSON.parse(item.data); // `orders` es ahora un array de objetos
    // Extraemos todos los productos de todos los pedidos
    const allProducts = orders.flatMap(order => JSON.parse(order.products));

    // Filtramos los productos por nombre para obtener un conteo de cada uno

    allProducts.forEach(product => {
      if (!productCount[product.name]) {
        productCount[product.name] = { count: 0, image: product.imagen };  // Guardamos la imagen también
      }
      productCount[product.name].count += 1;
    });
  } catch (e) {
    console.error('Error al parsear item.data:', e);
    return; // Si ocurre un error en el parseo, no continuamos
  }

  const pdf = new jsPDF();
  let yPosition = 20; // Coordenada Y inicial

  // Título principal
  pdf.setFontSize(16);
  pdf.text('Conteo de Productos', 90, yPosition);
  yPosition += 10;

  // Iteramos sobre los productos que tenemos en el conteo
  Object.keys(productCount).forEach((productName) => {
    const product = productCount[productName];
    
    // Título del producto
    pdf.setFontSize(14);
    pdf.text(`${productName} - Cantidad: ${product.count}`, 10, yPosition);
    yPosition += 10;

    // Añadir la imagen del producto si está disponible
    if (product.imagen) {
      try {
        // Agregamos la imagen si la URL es válida
        pdf.addImage(product.imagen, 'PNG', 150, yPosition, 30, 30);  // 150, yPosition, 30, 30 son las coordenadas y tamaño de la imagen
        yPosition += 35; // Ajustamos la posición después de agregar la imagen
      } catch (error) {
        console.error('Error al agregar la imagen:', error);
      }
    }

    // Espacio entre productos
    yPosition += 10;

    // Evitamos que se pase al siguiente PDF hasta que todos los productos del conteo se hayan añadido
    if (yPosition > 270) {  // Si la página está llena, agregamos una nueva página
      pdf.addPage();
      yPosition = 20; // Reiniciamos la posición Y
    }
  });

  // Guardar el PDF con un nombre dinámico utilizando la fecha del primer pedido (o cualquier otro criterio)
  pdf.save(`${item.date}-Conteo-Productos.pdf`);
};



  const [message, setMessage] = useState("")

  // FUNCIONES DE VISIBILIDAD
  const functionVisibilityOne = () => {
    setVisibilityRegister1(true);
    setVisibilityRegister2(false);
    setVisibilityInfo(true);
  };

  const functionVisibilityTwo = () => {
    setVisibilityRegister1(false);
    setVisibilityRegister2(true);
    setVisibilityInfo(false);
  };

  // CONECCION BACKEND
  useEffect(() => {
    fetch("https://backend-menue.onrender.com/registroGet")
      .then(res => res.json())
      .then(data => {
        setData(data);
        setVisibilityData(true);
        // console.log("esta es la data que llega al registro: " + JSON.stringify(data))
      })
      .catch(err => setConsoleAdmin(prevState => [...prevState, err]));
  }, [newFetch]);

  useEffect(() => {
    setNewFetch(newFetch + 1)
  }, [])

  const showDates = (day) => {
    setDataAdd(day);
    setVisibilityInfo(true);
    setThisDate(day);
if(dataAdd){
    console.log("esta es la estructura de dataAdd " + JSON.stringify(day))}
  };

  const showDates2 = (date) => {
    const dateSelect = data.find(dateDat => dateDat.date === date.date); // Asegúrate de que comparas correctamente.
    setThisDate(dateSelect);
  };

  // DESCRIPCION REGISTROS
  const functionDescription = () => {
    if (!dataAdd) return null;

    const orders = JSON.parse(dataAdd.data);

    return (
      <div className='container-info-date'>
        <h1>Pedidos:</h1>
        <ul>
          {orders.map((order, index) => {
            const products = JSON.parse(order.products);
            return (
              <li key={index} className='producto'>
                <h2>Pedido ID: {order.id}</h2>
                <ul>
                  {products.map((product, prodIndex) => (
                    <li key={prodIndex} className='list-product-register'>
                      <img src={product.imagen} alt={product.name || "Producto"} />
                      <h3>{product.name} - {product.kcal} kcal</h3>
                      <p>Ingredientes: {product.ingredients}</p>
                      <p>Precio: ${product.price}</p>
                    </li>
                  ))}
                </ul>
                <p>Ganancia de este pedido: ${order.totalPayOrder}</p>
              </li>
            );
          })}
        </ul>
        <div className='container-info-div'>
          <h1>Ganancia neta total:</h1>
          <h2>${dataAdd.totalPay}</h2>
        </div>
        
      </div>
    );
  };

  // FUNCION DE CONTABILIDAD
  const countProduct = (product) => {
    if (!thisDate || !thisDate.data) return <h2>0</h2>;
  
    const orders = JSON.parse(thisDate.data);
    const allProducts = orders.flatMap(order => JSON.parse(order.products));
    const filtProduct = allProducts.filter(pro => pro.name === product);
  
    return <h2>{filtProduct.length}</h2>;
  };

  // MAPEO DE LOS PRODUCTOS
  const mapeoProducts = (food) => {
   
    return (
    
    <div className='container-info-date'>
      <nav>
        <button onClick={() => { setVisibilityRegister2Food(true); setVisibilityRegister2Desserts(false); setVisibilityRegister2Drink(false); }}>Comidas</button>
        <button onClick={() => { setVisibilityRegister2Food(false); setVisibilityRegister2Desserts(false); setVisibilityRegister2Drink(true); }}>Bebidas</button>
        <button onClick={() => { setVisibilityRegister2Food(false); setVisibilityRegister2Desserts(true); setVisibilityRegister2Drink(false); }}>Postres</button>
      </nav>
      {food.map((item, index) => (
        <div key={index} style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}>
          <div className='producto-2'>
            <div style={{ display: "flex", flexDirection: "column", textAlign: "center", width: "80%", marginLeft: "calc(50% - 40%" }}>
              <h1>{item.name}</h1>
              {countProduct(item.name)}
            </div>
            <div style={{ padding: "10px", width: "20%" }} >
              <img src={item.imagen} alt={item.name || "Imagen de producto"} />
            </div>
          </div>
        </div>
      ))}
    </div>
  )};

  // ELIMINAR REGISTROS

  const handleDelete = async (id) => {
    // Preguntar al usuario si está seguro de eliminar el registro
    const confirmation = window.confirm("¿Está seguro de que desea eliminar este registro?");
    
    if (confirmation) {
      try {
        const response = await fetch('https://backend-menue.onrender.com/deleteOneRegister', {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id }),
        });
    
        // Esperar que la respuesta sea en formato JSON
        const data = await response.json();
    
        // Verificar si la respuesta es exitosa
        if (response.ok) {
          setNewFetch(prevFetch => prevFetch + 1);  // Utiliza una función de actualización para asegurar que el valor anterior se use correctamente
          alert(`Registro eliminado correctamente`);
        } else {
          // Si la respuesta no es exitosa, mostrar el error recibido
          setMessage(`Error: ${data.error || 'Error desconocido'}`);
        }
      } catch (error) {
        // Manejar errores de red u otros errores
        setMessage(`Error al eliminar el registro: ${error.message}`);
      }
    } else {
      // Si el usuario cancela, no hacer nada
      setMessage('Eliminación cancelada');
    }
  };
    


  // useEffect(() => {
  //   console.log("*******************esta es la estructura de this date: " +   JSON.stringify(thisDate))
  // }, [thisDate])

  // RETURN CENTRAL DE LA APLICACION
  let num = 0
            
  return (
    <div className='container-information-register'>
      <div style={{padding: "5px"}}>
        <button onClick={functionVisibilityOne}>Pedidos</button>
        <button onClick={functionVisibilityTwo}>Conteo</button>
      </div>

      {visibilityData && visibilityRegister1 && (
        <div className='information-register-buttons' style={{padding: "5px"}}>
          {data.map((item, index) => {
          
              // Parsear item.data a un objeto
      const parsedData = JSON.parse(item.data);
            return(
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center"}} key={index} className='container-btn-date' >
              <button className='btn-date' onClick={() => showDates(item)}>
                {item.date}
              </button>
              <button onClick={() => functionSavePdfDescription(item)} className='primary-button-pdf'><img className='pdf-icon' src={imgPDF} /></button>
              <button onClick={() => handleDelete(item.id)} style={{marginLeft: "5px"}}>X</button>
           
            
              {/* {message && <p style={{color: "red"}}>{message}</p>} */}
            </div>
          )})}
        </div>
      )}

      {visibilityData && visibilityRegister2 && (
        <div className='information-register-buttons' style={{padding: "5px"}}>
          {data.map((item, index) => (
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center"}} key={index} className='container-btn-date'>
              <button className='btn-date' onClick={() => showDates2(item)}>
                {item.date}
              </button>
              <button onClick={() => functionSavePdfDescription2(item)} className='primary-button-pdf'><img className='pdf-icon' src={imgPDF} /></button>
              <button onClick={() => handleDelete(item.id)} style={{marginLeft: "5px"}}>X</button>
          </div>
          ))}
        </div>
      )}

      <div className='container-info-date'>
        {visibilityInfo && dataAdd && functionDescription()}
        {visibilityRegister2 && (
          <>
            {visibilityRegister2Food && mapeoProducts(hamburguesas)}
            {visibilityRegister2Desserts && mapeoProducts(desserts)}
            {visibilityRegister2Drink && mapeoProducts(drinks)}
          </>
        )}
      </div>
    </div>
  );
}

export default Register;



